<template>
  <div>

    <b-row style="border-top: 2px solid #9e9e9e;padding: 7px;padding-top:10px;padding-bottom:0;background-color: #fff"
           :style="{borderTop: headerStyles(issue)}">


      <b-col md="2" cols="3" class="my-0">
        <b-badge v-if="issue.board" pill variant="info" class="text-right p-1" style="float: right"
                 :style="{backgroundColor: boardColor(issue.board.id)}">
          {{ issue.board.title }}
        </b-badge>

      </b-col>

      <b-col md="10" cols="9" class="my-0" style="min-width: 200px">
        <h6 v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{ issue.title }}</h6>


      </b-col>


      <b-col v-if="issueMoreDetailShow" md="2" cols="3" class="my-1">


        <span v-b-tooltip.hover title="اولویت زیاد" v-if="issue.priority == 3" class="text-right text-danger" size="sm"><i
            class="fas fa-thermometer-full"></i></span>
        <span v-b-tooltip.hover title="اولویت متوسط" v-else-if="issue.priority == 2" class="text-right text-dark"
              size="sm"><i class="fas fa-thermometer-half"></i></span>
        <span v-b-tooltip.hover title="اولویت کم" v-else-if="issue.priority == 1" class="text-right text-secondary"
              size="sm"><i class="fas fa-thermometer-empty"></i></span>


      </b-col>

      <b-col v-if="issueMoreDetailShow" md="6" cols="5" class="my-1">


        <router-link :to="{path :'/issue/'+issue.id }"
                     :id="'tooltip-target-issueShow-'+issue.id"
                     style="cursor: pointer" class="text-default  ml-2">
          <i class="fas fa-eye"></i>
        </router-link>
        <b-tooltip placement="bottom" :target="'tooltip-target-issueShow-'+issue.id"
                   triggers="hover">
          <small>نمایش Issue </small>
        </b-tooltip>


        <span v-if="issue.contact_id && issue.contact" :id="'tooltip-target-'+issue.id"
              style="cursor: pointer" class="text-success  ml-2">
                                              <i class="fas fa-address-book"></i>
                                          </span>
        <b-tooltip placement="bottom" v-if="issue.contact_id && issue.contact" :target="'tooltip-target-'+issue.id"
                   triggers="hover">
          <small>مشتری: </small>
          {{ issue.contact.last_name }}
        </b-tooltip>


        <span v-if="issue.project_id && issue.project" :id="'tooltip-target-project-'+issue.id"
              style="cursor: pointer" class="text-info ml-2">
                                              <i class="fas fa-handshake"></i>
                                          </span>
        <b-tooltip placement="bottom" v-if="issue.project_id && issue.project"
                   :target="'tooltip-target-project-'+issue.id" triggers="hover">
          <small>پروژه: </small>
          {{ issue.project.title }}
        </b-tooltip>


        <span v-if="issue.process">
                        <span v-if="issue.process.steps">
                              <span v-for="(step, stepIconListIndex) in issue.process.steps"
                                    v-if="step.id === issue.step_id" :key="'stepIconList'+stepIconListIndex"
                                    :id="'tooltip-target-step-'+issue.id"
                                    style="cursor: pointer" class="text-dark ml-2">
                                              <i class="fas fa-random"></i>
                    </span>
                            <b-tooltip v-for="(step, stepTooltipListIndex) in issue.process.steps"
                                       v-if="step.id === issue.step_id" :key="'stepTooltipList'+stepTooltipListIndex"
                                       placement="bottom" :target="'tooltip-target-step-'+issue.id" triggers="hover">
                                <small>مرحله: </small>
                                {{ step.title }}
                            </b-tooltip>
                        </span>
                    </span>


        <span :id="'tooltip-target-created-'+issue.id"
              style="cursor: pointer" class="text-secondary  ml-2">
                                              <i class="fas fa-calendar"></i>
                                          </span>
        <b-tooltip placement="bottom" :target="'tooltip-target-created-'+issue.id" triggers="hover">
          <small>تاریخ ثبت: </small>
          {{ issue.created_at| moment("dddd, jD jMMMM") }}
        </b-tooltip>


         <span @click="showJson = !showJson"
               :id="'tooltip-target-json-'+issue.id" style="cursor: pointer" class="text-info  ml-2">
                                              <i class="fab fa-js"></i>
         </span>
        <b-tooltip placement="bottom" :target="'tooltip-target-json-'+issue.id" triggers="hover">
          Show Json
        </b-tooltip>


      </b-col>

      <b-col v-if="issueMoreDetailShow" md="4" cols="4" class="my-1 text-left text-sm">
        <small class="text-color-blue mt-1 mr-2">

          <span v-if="issue.type_object" v-b-tooltip.hover :title="issueTypeText(issue)"
                v-text="issue.type_object.title" class="badge badge-secondary pt-1"
                :style="{backgroundColor: typeBadgeStyles(issue)}"></span>

        </small>
      </b-col>

    </b-row>



    <b-row class="mb-5">
      <b-col class="p-2 py-5" style="background-color: #f6f6f6; color: #333">


        <b-row class="mb-2 p-2" v-for="(history, historyIndex) in issueHistory" :key="historyIndex">
          <b-col class="p-1 bg-white">

            <b-row class="mt-2">
              <b-col> {{ history.updated_at| moment("dddd, jD jMMMM") }}</b-col>
              <b-col> {{ history.description }}</b-col>
              <b-col> User: {{ history.causer_id }}</b-col>
            </b-row>

            <hr>

            <b-row>
              <b-col md="5" class="mt-1 text-black-50" v-if="history.properties.old">


                <b v-if="history.properties.old.title">عنوان: {{ history.properties.old.title }} <br></b>
                <b v-if="history.properties.old.description">توضیحات: {{ history.properties.old.description }}<br></b>
                <b v-if="history.properties.old.priority">اولویت: {{ history.properties.old.priority }}<br></b>
                <b v-if="history.properties.old.state">وضع: {{ history.properties.old.state }}<br></b>
                <b v-if="history.properties.old.type">نوع: {{ history.properties.old.type }}<br></b>
                <b v-if="history.properties.old.parent_id">پرنت: {{ history.properties.old.parent_id }}<br></b>

                <b v-if="history.properties.old.estimated_time">زمان تخمینی: {{ history.properties.old.estimated_time }}<br></b>
                <b v-if="history.properties.old.progress_input">میزان پیشرفت: {{ history.properties.old.progress_input }}<br></b>
                <b v-if="history.properties.old.progress_generated">میزان پیشرفت: {{ history.properties.old.progress_generated }}<br></b>

                <b v-if="history.properties.old.start_date">تاریخ شروع: {{ history.properties.old.start_date }}<br></b>
                <b v-if="history.properties.old.due_date">تاریخ جهت انجام: {{ history.properties.old.due_date }}<br></b>
                <b v-if="history.properties.old.done_date">تاریخ انجام: {{ history.properties.old.done_date }}<br></b>
                <b v-if="history.properties.old.close_date">تاریخ بسته شده: {{ history.properties.old.close_date }}<br></b>

                <b v-if="history.properties.old.order_id">کد سفارش: {{ history.properties.old.order_id }}<br></b>

                <b v-if="history.properties.old['process.title']">فرایند: {{ history.properties.old['process.title'] }}<br></b>
                <b v-if="history.properties.old['step.title']">مرحله: {{ history.properties.old['step.title'] }}<br></b>
                <b v-if="history.properties.old['board.title']">وضعیت: {{ history.properties.old['board.title'] }}<br></b>
                <b v-if="history.properties.old['project.title']">پروژه: {{ history.properties.old['project.title'] }}<br></b>
                <b v-if="history.properties.old['contact.last_name']">مشتری: {{ history.properties.old['contact.last_name'] }}<br></b>


                <b v-if="history.properties.old.blongUsers"> کابران تخصیصی: {{ history.properties.old.blongUsers }}<br></b>

                <b v-if="history.properties.old.tags">  برچسب ها: {{ history.properties.old.tags }}<br></b>




                <div v-if="showJson">
                  <br><hr><small> {{ history.properties.old }}</small>
                </div>

              </b-col>

              <b-col md="2" class="mt-1 d-flex justify-content-center align-content-center align-items-center"
                     v-if="history.properties.old">

                <i class="fa fa-arrow-left fa-2x"></i>

              </b-col>

              <b-col md="5" class="mt-1 text-success" v-if="history.properties.attributes">



                <b v-if="history.properties.attributes.title">عنوان: {{ history.properties.attributes.title }}<br></b>
                <b v-if="history.properties.attributes.description">توضیحات: {{ history.properties.attributes.description }}<br></b>
                <b v-if="history.properties.attributes.priority">اولویت: {{ history.properties.attributes.priority }}<br></b>
                <b v-if="history.properties.attributes.state">وضع: {{ history.properties.attributes.state }}<br></b>
                <b v-if="history.properties.attributes.type">نوع: {{ history.properties.attributes.type }}<br></b>
                <b v-if="history.properties.attributes.parent_id">پرنت: {{ history.properties.attributes.parent_id }}<br></b>

                <b v-if="history.properties.attributes.estimated_time">زمان تخمینی: {{ history.properties.attributes.estimated_time }}<br></b>
                <b v-if="history.properties.attributes.progress_input">میزان پیشرفت: {{ history.properties.attributes.progress_input }}<br></b>
                <b v-if="history.properties.attributes.progress_generated">میزان پیشرفت: {{ history.properties.attributes.progress_generated }}<br></b>

                <b v-if="history.properties.attributes.start_date">تاریخ شروع: {{ history.properties.attributes.start_date }}<br></b>
                <b v-if="history.properties.attributes.due_date">تاریخ جهت انجام: {{ history.properties.attributes.due_date }}<br></b>
                <b v-if="history.properties.attributes.done_date">تاریخ انجام: {{ history.properties.attributes.done_date }}<br></b>
                <b v-if="history.properties.attributes.close_date">تاریخ بسته شده: {{ history.properties.attributes.close_date }}<br></b>

                <b v-if="history.properties.attributes.order_id">کد سفارش: {{ history.properties.attributes.order_id }}<br></b>

                <b v-if="history.properties.attributes['process.title']">فرایند: {{ history.properties.attributes['process.title'] }}<br></b>
                <b v-if="history.properties.attributes['step.title']">مرحله: {{ history.properties.attributes['step.title'] }}<br></b>
                <b v-if="history.properties.attributes['board.title']">وضعیت: {{ history.properties.attributes['board.title'] }}<br></b>
                <b v-if="history.properties.attributes['project.title']">پروژه: {{ history.properties.attributes['project.title'] }}<br></b>
                <b v-if="history.properties.attributes['contact.last_name']">مشتری: {{ history.properties.attributes['contact.last_name'] }}<br></b>


                <b v-if="history.properties.attributes.blongUsers"> کابران تخصیصی: {{ history.properties.attributes.blongUsers }}<br></b>

                <b v-if="history.properties.attributes.tags">  برچسب ها: {{ history.properties.attributes.tags }}<br></b>





                <div v-if="showJson">
                  <br><hr><small> {{ history.properties.attributes }}</small>
                </div>


              </b-col>
            </b-row>


          </b-col>
        </b-row>


      </b-col>
    </b-row>


  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import Multiselect from 'vue-multiselect'

import InnerImageZoom from 'vue-inner-image-zoom';


import lodash from 'lodash'
import issueItemShow from "./item";


export default {
  name: 'issueShow',
  components: {


    Multiselect,

    issueItemShow,


    'inner-image-zoom': InnerImageZoom


  },


  props: {},


  data() {
    return {

      auth: {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token')
        }
      },

      role: localStorage.getItem('role'),
      authUser:
          {
            id: localStorage.getItem('id'),
          },

      loadMore: true,
      page: 1,
      pageSize: 10,
      voice: '',

      courseCategories: [],
      fileCategories: [],
      forumCategories: [],
      forums: [],


      issue: {},


      rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

      issueMoreDetailShow: true,

      issueId: null,


      issueHistory: [],

      showJson: false,

    }
  },


  watch: {},


  beforeRouteUpdate(to, from, next) {

    // this.issueId = to.params.id
    this.getIssue(to.params.id)
    this.getIssueHistory(to.params.id)

    next();
  },


  mounted() {

    this.issueId = this.$route.params.id
    this.getIssue(this.issueId)
    this.getIssueHistory(this.issueId)

  },


  methods: {


    getIssue($id) {
      var app = this;

      axios.get('/api/intro/issue/show/' + $id, app.auth)
          .then(function (response) {
            app.issue = response.data
            // console.log(response.data);
          })
          .catch(function (e) {
            console.log(e.response);
          });
    },

    getIssueHistory($id) {
      var app = this;

      axios.get('/api/intro/issue/history/' + $id, app.auth)
          .then(function (response) {
            app.issueHistory = response.data.data
            // console.log(response.data);
          })
          .catch(function (e) {
            console.log(e.response);
          });
    },


    color(value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    },

    bottomVisible() {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      return bottomOfPage || pageHeight < visible
    },

    pluck(array, key) {
      return array.map(function (obj) {
        return obj[key];
      });
    },

    showIssueText(text, index) {

      this.issues[index].intro = text

    },

    onResult(data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
      this.srcPlay = window.URL.createObjectURL(data)
      this.src = data

    },

    headerStyles(issueType) {
      if (issueType.type == 1)
        return '2px solid #880e4e'
      else if (issueType.type == 2)
        return '2px solid #f50057'
      else if (issueType.type == 3)
        return '2px solid #8e24aa'
      else if (issueType.type == 4)
        return '2px solid #263238'
      else if (issueType.type == 5)
        return '2px solid #dd2c00'
      else if (issueType.type == 6)
        return '2px solid #00c853'
      else if (issueType.type == 7)
        return '2px solid #0097a7'
      else if (issueType.type == 8)
        return '2px solid #0288d1'
      else if (issueType.type == 9)
        return '2px solid #0208ff'
      else if (issueType.type == 10)
        return '2px solid #eeb600'
      else if (issueType.type == 10)
        return '2px solid #0e8e2e'
      else if (issueType.type == 11)
        return '2px solid #888'
      else
        return '2px solid #888888'
    },

    boardColor(boardID) {
      if (boardID == 1)
        return '#ee6600'
      else if (boardID == 2)
        return '#ffd600'
      else if (boardID == 3)
        return '#aeb130'
      else if (boardID == 4)
        return '#64dd17'
      else if (boardID == 5)
        return '#0097a7'
      else if (boardID == 6)
        return '#00bfa5'
      else
        return ''
    },

    typeBadgeStyles(issueType) {
      if (issueType.type == 1)
        return '#880e4e'
      else if (issueType.type == 2)
        return '#f50057'
      else if (issueType.type == 3)
        return '#8e24aa'
      else if (issueType.type == 4)
        return '#263238'
      else if (issueType.type == 5)
        return '#dd2c00'
      else if (issueType.type == 6)
        return '#00c853'
      else if (issueType.type == 7)
        return '#0097a7'
      else if (issueType.type == 8)
        return '#0288d1'
      else if (issueType.type == 9)
        return '#0208ff'
      else if (issueType.type == 10)
        return '#eeb600'
      else if (issueType.type == 10)
        return '#0e8e2e'
      else if (issueType.type == 11)
        return '#888'
      else
        return '#888888'
    },

    issueTypeText(issueType) {
      if (issueType.type == 1)
        return 'سرنخ (Lead)'
      else if (issueType.type == 2)
        return 'فرصت (Opportunity)'
      else if (issueType.type == 3)
        return 'ملاقات/جلسه/رویداد'
      else if (issueType.type == 4)
        return 'پیگیری (Ticket)'
      else if (issueType.type == 5)
        return 'ایراد (Bug)'
      else if (issueType.type == 6)
        return 'فعالیت (Task)'
      else if (issueType.type == 7)
        return 'لیست/شرح (Story)'
      else if (issueType.type == 8)
        return 'مجموعه/امکانات (Epic)'
      else if (issueType.type == 9)
        return 'پیام/تلفن (Message)'
      else if (issueType.type == 10)
        return 'گزارش/خبر (Report)'
      else if (issueType.type == 11)
        return 'سایر'
      else
        return 'سایر'
    },


  }


}
</script>


<style scoped>


tr {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, .15);

}


</style>
